import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface FullPageLoaderProps {
  message?: string;
}

const LoaderContainer = styled(Box)(() => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.75)',
  backdropFilter: 'blur(2px)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
}));

const FullPageLoader: React.FC<FullPageLoaderProps> = ({ 
  message = 'Please wait while we set you up...' 
}) => {
  return (
    <LoaderContainer>
      {/* Main heading */}
      <Typography 
        variant="h5" 
        sx={{ 
          fontWeight: 600, 
          color: '#262728', 
          mb: 5, 
          letterSpacing: -0.5,
          textAlign: 'center',
          fontSize: "24px !important"
        }}
      >
        {message}
      </Typography>
      
      {/* Progress bar */}
      <Box sx={{ width: 320, position: 'relative' }}>
        <Box
          sx={{
            height: 6,
            borderRadius: 3,
            background: 'rgba(148, 163, 184, 0.15)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              top: 0,
              height: '100%',
              width: '35%',
              background: 'linear-gradient(90deg, var(--primary) 0%, #007A56 50%, #00A572 100%)',
              borderRadius: 3,
              animation: 'progressSlide 2.5s ease-in-out infinite',
              '@keyframes progressSlide': {
                '0%': { 
                  transform: 'translateX(-100%)',
                  width: '30%'
                },
                '50%': { 
                  transform: 'translateX(180%)',
                  width: '50%'
                },
                '100%': { 
                  transform: 'translateX(400%)',
                  width: '30%'
                },
              },
            }}
          />
        </Box>
      </Box>
    </LoaderContainer>
  );
};

export default FullPageLoader;
